import React from 'react';
import { IonItem, IonLabel, IonText } from '@ionic/react';
import type { ColorSelectionListRowProps } from 'features/shared/inventory/selections/color-selections/types/ColorSelectionListRowProps';
import type { InventoryItem } from 'core/types';
import 'features/shared/inventory/selections/color-selections/components/ColorSelectionListRowDesktop.scss';

const na = (val: string) => (val.trim() !== '' ? val.trim() : 'N/A');

/**
 * Desktop colors row inside an accordion section grouped by
 * `colorGroupCode` (inventory group 68). Shows only the title
 * (`itemDesc`) — no pills, hex value, color swatch, or click-through per
 * the approved prototype.
 */
const ColorSelectionListRowDesktop: React.FC<ColorSelectionListRowProps> = ({
  title
}) => {
  return (
    <IonItem lines="none" className="hk-desktop-color-selections-redesign-item">
      <IonLabel className="hk-desktop-color-selections-redesign-item-body">
        <IonText className="hk-desktop-color-selections-redesign-item-name">
          <p>{na(title)}</p>
        </IonText>
      </IonLabel>
    </IonItem>
  );
};

export default ColorSelectionListRowDesktop;

export function inventoryItemToColorSelectionRowProps(
  item: Pick<InventoryItem, 'attributes'>
): ColorSelectionListRowProps {
  const itemDesc = item.attributes?.itemdesc ?? '';
  const colorDesc = item.attributes?.colordesc ?? '';
  return {
    title: colorDesc ? `${itemDesc} - ${colorDesc}` : itemDesc
  };
}
